var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("header", { staticClass: "chat-header" }, [
    _c("div", { staticClass: "venue-logo" }, [
      _vm.venue.logo ? _c("img", { attrs: { src: _vm.venue.logo } }) : _vm._e(),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "venue-name" }, [
      _vm._v("\n    " + _vm._s(_vm.venue.name) + "\n  "),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "close-chat" }, [
      _c(
        "a",
        {
          attrs: { href: "#" },
          on: {
            click: function ($event) {
              $event.preventDefault()
              _vm.closeChat($event)
            },
          },
        },
        [_c("i", { staticClass: "icon ion-close-round" })]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/loaders/templateLoader.js?{"loaders":{"css":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}}],"postcss":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}}],"less":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"less-loader","options":{"sourceMap":true}}],"sass":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"sass-loader","options":{"indentedSyntax":true,"sourceMap":true}}],"scss":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"sass-loader","options":{"sourceMap":true}}],"stylus":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"stylus-loader","options":{"sourceMap":true}}],"styl":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"stylus-loader","options":{"sourceMap":true}}]}}!./src/components/ChatHeader/template.html?vue&type=template&id=9e4d8b10&
// module id = 1033
// module chunks = 0